module.exports = __webpack_public_path__ + "img/productRobot_25.bc43eba2.png";